export default __webpack_public_path__ + "static/media/ec1Closed.5de8e2da.jpg";